import { render, staticRenderFns } from "./LogoFoto.vue?vue&type=template&id=cb5e0246&scoped=true"
import script from "./LogoFoto.vue?vue&type=script&lang=js"
export * from "./LogoFoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5e0246",
  null
  
)

export default component.exports